import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import School from '../../../models/School'

const loadSchoolOptionsQuery = ({ valueField, customerOnly }) => (value, callback) => {
  const filters = { name: { match: value } }
  if (customerOnly) filters.salesStatIn = { eq: ['CUST', 'NCUST'] }

  School
    .where(filters)
    .order({ name: 'asc' })
    .all()
    .then((res) => {
      const options = res.data.map((e) => ({ label: e.cityName ? `${e.name} (${e.cityName})` : e.name, value: e[valueField], data: e }))
      callback(options)
    })
}

const SchoolAllAsyncSelect = ({
  name, selectedValue, valueField, extraFields, placeholder, customerOnly,
}) => {
  const [option, setOption] = useState(selectedValue)

  const loadSchoolOptions = loadSchoolOptionsQuery({ valueField, customerOnly })

  const changeHandler = (opt) => {
    const { pathname } = window.location

    if (pathname.includes('fall_request_form')) {
      setOption(opt);
      
    } else if (pathname === '/export/students' || pathname.includes('/export/school_user')) {
      window.location = `/export/school_user/${opt.data.id}`;
    } else if (pathname.includes('yearbooks')) {
      window.location = `/yearbooks?school_id=${opt.data.id}`;
    
     
    } else if (pathname.includes('yearbooks')) {
      window.location = `/yearbooks?school_id=${opt.data.id}`;
    
    
    } else if (pathname === '/admin/schools' || pathname.includes('admin_school_sales_call')) {
      window.location = `/admin/schools/${opt.data.id}/edit`;
    } else if (pathname === '/contracts') {
      // Clearing always navigates to drop the school_id from the URL so the
      // list re-renders against the active status filter.
      if (!opt) {
        const params = new URLSearchParams(window.location.search);
        params.delete('school_id');
        window.location = `/contracts?${params.toString()}`;
        return;
      }
      // Otherwise just update the hidden input — the user picks Find Contract
      // or Generate Contract to take action.
      const hidden = document.querySelector('input[type=hidden][name="school_id"]');
      if (hidden) {
        hidden.value = opt.data.id;
        setOption(opt);
        return;
      }
      const params = new URLSearchParams(window.location.search);
      params.set('school_id', opt.data.id);
      window.location = `/contracts?${params.toString()}`;
    } else {
      setOption(opt)
    }
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        isClearable
        placeholder={placeholder}
        defaultValue={option}
        name={name}
        loadOptions={loadSchoolOptions}
        onChange={changeHandler}
      />
      {option && option.data && extraFields?.length > 0 && (
        <ExtraFields data={option.data} fields={extraFields} />
      )}
    </>
  )
}

const ExtraFields = ({ data, fields }) => (
  fields.map((field) => (
    <input
      key={field.fieldName}
      name={field.fieldName}
      value={data[field.attributeName]}
      readOnly
      hidden
    />
  ))
)

SchoolAllAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
  customerOnly: PropTypes.bool,
}

SchoolAllAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search All',
  customerOnly: false,
}

export default SchoolAllAsyncSelect
